export default __webpack_public_path__ + "static/media/webRTC.75e5ddbb.png";